import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TouristGuideIntegration } from '../_models/tourist-guides-integration.model';

@Injectable({ providedIn: 'root' })
export class TouristGuidesIntegrationApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.erpSymfonyUrl;

	getIntegration(touristGuideId: string): Observable<{ data: TouristGuideIntegration }> {
		return this.httpClient.get<{ data: TouristGuideIntegration }>(
			`${this.apiUrl}/tourist-guide/${touristGuideId}/integration`,
		);
	}

	saveIntegration(
		touristGuideId: string,
		payload: TouristGuideIntegration,
	): Observable<{ data: TouristGuideIntegration }> {
		return this.httpClient.put<{ data: TouristGuideIntegration }>(
			`${this.apiUrl}/tourist-guide/${touristGuideId}/integration`,
			payload,
		);
	}
}
